exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#compliance-commitment{width:100%}#compliance-commitment tr{border:1px dotted grey}#compliance-commitment td{padding:.8rem}#compliance-commitment .name{text-align:justify}#compliance-commitment .is-checked{width:5%;text-align:center}", ""]);

// exports
